import SHARED_ACTION_TYPES from '../constants/SharedConstants'

// Notifications
export const setNotif = (payload) => ({ type: SHARED_ACTION_TYPES.SET_NOTIF, payload })
export const killNotif = () => ({ type: SHARED_ACTION_TYPES.KILL_NOTIF })
export const setUserType = (payload) => ({ type: SHARED_ACTION_TYPES.SET_USERTYPE, payload })
export const setUnitData = (payload) => ({ type: SHARED_ACTION_TYPES.SET_UNITDATA, payload })
